import { ArrowUpRight, Plus } from 'lucide-react';
import { css, cx } from 'styled-system/css';
import { splitEntryClass } from '../SplitSection';
import type { FaqItem } from './faqItems';

export function FaqEntry({ item }: { item: FaqItem }) {
  return (
    <details
      id={`faq-${item.id}`}
      className={cx(
        splitEntryClass(),
        css({
          '& > summary::-webkit-details-marker': { display: 'none' },
          '&[open] [data-faq-icon]': { transform: 'rotate(45deg)' },
        }),
      )}
    >
      <summary
        className={css({
          listStyle: 'none',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: '6',
          paddingBlock: { base: '5', md: '6' },
          cursor: 'pointer',
          fontFamily: 'sans',
          fontWeight: 'semibold',
          fontSize: { base: 'md', md: 'lg' },
          letterSpacing: 'tight',
          lineHeight: 'snug',
          color: 'text.primary',
          transition: 'color 200ms {easings.out}',
          _hover: { color: 'text.secondary' },
          _focusVisible: {
            outline: '2px solid token(colors.border.focus)',
            outlineOffset: '2px',
          },
        })}
      >
        <span>{item.question}</span>
        <Plus
          aria-hidden="true"
          data-faq-icon
          className={css({
            flexShrink: 0,
            width: '5',
            height: '5',
            color: 'text.muted',
            transition: 'transform 320ms {easings.out}',
            _motionReduce: { transition: 'none' },
          })}
        />
      </summary>
      <div
        className={css({
          paddingBottom: { base: '6', md: '7' },
          maxWidth: '62ch',
        })}
      >
        <p
          className={css({
            fontSize: { base: 'base', md: 'md' },
            lineHeight: 'relaxed',
            color: 'text.secondary',
            textWrap: 'pretty',
          })}
        >
          {item.answer}
        </p>
        <a
          href={item.learnMore.href}
          className={css({
            display: 'inline-flex',
            alignItems: 'center',
            gap: '1',
            marginTop: '4',
            fontSize: 'sm',
            fontWeight: 'medium',
            color: 'text.primary',
            textDecoration: 'underline',
            textDecorationColor: 'border.hairline',
            textUnderlineOffset: '4px',
            transition: 'text-decoration-color 200ms {easings.out}',
            _hover: { textDecorationColor: 'text.primary' },
            _focusVisible: {
              outline: '2px solid token(colors.border.focus)',
              outlineOffset: '2px',
            },
          })}
        >
          Learn more: {item.learnMore.label}
          <ArrowUpRight
            aria-hidden="true"
            className={css({ width: '4', height: '4' })}
          />
        </a>
      </div>
    </details>
  );
}
